import React from 'react';
import { CircularProgress } from 'src/components';

interface LoadingStateProps {
  height?: string;
  size?: 'sm' | 'md' | 'lg';
}

const StrategyLoadingState: React.FC<LoadingStateProps> = ({
  height = 'h-full',
  size = 'lg',
}) => {
  return (
    <div
      className={`flex items-center justify-center w-full ${height} bg-slate-100`}
    >
      <CircularProgress size={size} color="primary" />
    </div>
  );
};

export default StrategyLoadingState;
